var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"media__link",class:_vm.linksItem.name},[_c('a',{attrs:{"href":_vm.linksItem.url}},[_c('span',{staticClass:"media__icon",style:({backgroundImage: _vm.linksItem.background})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }